import { Box, Stack, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { isNumber, capitalize } from "lodash/fp";
import CarLogoBrand from "./CarLogoBrand";

type Props = {
  carBrand: string;
  emissionCO2: number;
  carModel: string;
  licensePlate: string;
  inputValue: string;
};

const CarSelectRenderOption = ({
  inputValue,
  carBrand,
  emissionCO2,
  carModel,
  licensePlate,
}: Props) => {
  const brandLabel = capitalize(carBrand ?? "");
  const modelLabel = capitalize(carModel ?? "");
  const carLabel = [brandLabel, modelLabel].filter(Boolean).join(" ");

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={0.5}
      width="100%"
      minWidth={0}
      sx={{ "& > img": { mr: 1, flexShrink: 0 } }}
    >
      {carBrand || carModel || licensePlate ? (
        <>
          <CarLogoBrand size="small" carBrand={carBrand ?? ""} />
          <Typography
            component="span"
            noWrap
            sx={{ flex: 1, minWidth: 0 }}
            title={carLabel}
          >
            {carLabel}
            {licensePlate ? ` · ${licensePlate}` : ""}
          </Typography>
          {isNumber(emissionCO2) ? (
            <Typography
              variant="caption"
              color="success.main"
              sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
            >
              {Math.round(emissionCO2)}gCO2/km
            </Typography>
          ) : null}
        </>
      ) : (
        <>
          <SearchIcon />
          <Stack>
            <Typography>Search by license plate</Typography>
            <Typography variant="body1" color="success.main">
              • {inputValue}
            </Typography>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default CarSelectRenderOption;
